import script from "./FinishTripPayment.vue?vue&type=script&lang=ts&setup=true"
export * from "./FinishTripPayment.vue?vue&type=script&lang=ts&setup=true"

import "./FinishTripPayment.vue?vue&type=style&index=0&id=add55668&scoped=true&lang=css"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-add55668"]])

export default __exports__